import { ServiceProxyMap, createAxiosClient } from '@atlassian/temp-client-utils';

const client = createAxiosClient({ baseURL: '/api/1/preference-management' }, ServiceProxyMap.PPC_BFF);

export const getNotificationPreferencesByTransactionAccountId = async (transactionAccountId: string) => {
  const response = await client.get(`/transaction-account/${transactionAccountId}`);
  return response.data;
};

export const getNotificationPreferencesByAtlassianAccountId = async (atlassianAccountId: string) => {
  const response = await client.get(`/atlassian-account/${atlassianAccountId}`);
  return response.data;
};

export type SetNotificationPreferencesProxyRequestParams = Array<{
  userAaid: string;
  entitlementId?: string;
  transactionAccountId: string;
  notificationPreferences: [
    {
      type: string;
      enabled: boolean;
      level?: string;
    }
  ];
}>;

export const setNotificationPreferences = async (payload: SetNotificationPreferencesProxyRequestParams) => {
  const response = await client.post(`/set-preferences`, payload);
  return response.data;
};
